import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const signup = async (email, gender) => {
  const response = await axios.post(`${API_URL}/api/auth/signup`, { email, gender });
  return response.data;
};

export const login = async (userID, password) => {
  const response = await axios.post(`${API_URL}/api/auth/login`, { userID, password });
  return response.data;
};

export const logout = async () => {
  const response = await axios.post(`${API_URL}/api/auth/logout`);
  return response.data;
}; 